import { useEffect, useRef } from 'react';

/*
 * Вызывает колбэк внутри рендер функции только один раз при изменении условия
 * @param errorMessage метка для сообщения об ошибке
 * @param condition условие
 * @param cb функция колбек
 */
export function useSingleFunctionCallOnRender(errorMessage: string, condition: boolean, cb: () => void) {
    // Количество перезапусков рендер функции
    // максимум 2 (для hot-module-replacement)
    const refCanRunCallback = useRef(0);

    // eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723
    if (condition && refCanRunCallback.current < 2) {
        // eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723
        refCanRunCallback.current += 1;
        cb();
    }

    // eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723
    if (__IS_DEV__ && condition && refCanRunCallback.current >= 2) {
        throw new Error(errorMessage);
    }

    useEffect(() => {
        refCanRunCallback.current = 0;
    });
}
